export default "__VITE_ASSET__c67e049a__"